import { render, staticRenderFns } from "./AccessSettings.vue?vue&type=template&id=6a642b00&scoped=true&"
import script from "./AccessSettings.vue?vue&type=script&lang=js&"
export * from "./AccessSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a642b00",
  null
  
)

export default component.exports